module.exports = __webpack_public_path__ + "static/sample-6dbc310d88fc6b81d182f6c88793df23.png";